module.exports = __webpack_public_path__ + "img/01.e8208397.png";